import { routerReducer } from 'react-router-redux';
import common from './reducers/common';
import header from './reducers/header';
import footer from './reducers/footer';
import category from './reducers/category';
import product from './reducers/product';
import cart from './reducers/cart';
import auth from './reducers/auth';
import cmsMapping from './reducers/cmsMapping';
import categoryCarousel from './reducers/categoryCarousel';
import order from './reducers/order';
import collectionPage from './reducers/collectionPage';
import DataLayer from './reducers/DataLayer';
import DTM from './reducers/DTM';
import campaign from './reducers/campaign';
import myAccount from './reducers/myAccount';
import savedCards from './reducers/savedCards';
import neft from './reducers/neft';
import productCarousel from './reducers/productCarousel';
import yotpo from './reducers/yotpo';
import home from './reducers/home';
import gupshupWhatsapp from './reducers/gupshupWhatsapp';
import frameSize from './reducers/frameSize';
// conditional imports on compilation
'#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
import checkout from './reducers/checkout';
import address from './reducers/address';
import shortlist from './reducers/shortlist';
import ditto from './reducers/ditto';
import success from './reducers/success';
import editPower from './reducers/editPower';
'#endif'; // eslint-disable-line

export default function createReducers(asyncReducers) {
  let returnObj;
  returnObj = {
    router: routerReducer,
    common,
    header,
    cart,
    cmsMapping,
    category,
    product,
    auth,
    categoryCarousel,
    footer,
    campaign,
    order,
    collectionPage,
    DataLayer,
    DTM,
    myAccount,
    savedCards,
    neft,
    productCarousel,
    yotpo,
    gupshupWhatsapp,
    home,
    frameSize,
    ...asyncReducers
  };
  // conditional imports on compilation
  '#if CLIENT_TYPE === "desktop"'; // eslint-disable-line
  returnObj = {
    ...returnObj,
    ...{
      checkout,
      address,
      shortlist,
      ditto,
      success,
      editPower
    }
  };
  '#endif'; // eslint-disable-line
  return returnObj;
}
